import { render, staticRenderFns } from "./ReasonOfScore.vue?vue&type=template&id=304ec112&"
import script from "./ReasonOfScore.vue?vue&type=script&lang=js&"
export * from "./ReasonOfScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports